var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M18.5625 9.92922V17.875C18.5625 18.0573 18.4901 18.2322 18.3611 18.3611C18.2322 18.4901 18.0573 18.5625 17.875 18.5625H4.125C3.94266 18.5625 3.7678 18.4901 3.63886 18.3611C3.50993 18.2322 3.4375 18.0573 3.4375 17.875V9.92922C3.43751 9.83341 3.45754 9.73867 3.49632 9.65105C3.53509 9.56344 3.59175 9.4849 3.66266 9.42047L10.5377 2.92875C10.6642 2.81353 10.8293 2.74968 11.0004 2.74968C11.1716 2.74968 11.3366 2.81353 11.4632 2.92875L18.3382 9.42047C18.409 9.48498 18.4655 9.56355 18.5041 9.65116C18.5427 9.73877 18.5626 9.83348 18.5625 9.92922Z",
    fill: "#2357A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8057 8.91774L11.9307 2.43118C11.9273 2.42824 11.9242 2.42508 11.9213 2.42172C11.6681 2.19152 11.3383 2.06396 10.9961 2.06396C10.654 2.06396 10.3241 2.19152 10.071 2.42172L10.0616 2.43118L3.1943 8.91774C3.05422 9.04655 2.9424 9.20303 2.86592 9.37729C2.78944 9.55155 2.74997 9.73978 2.75 9.93008V17.875C2.75 18.2397 2.89487 18.5894 3.15273 18.8473C3.41059 19.1051 3.76033 19.25 4.125 19.25H17.875C18.2397 19.25 18.5894 19.1051 18.8473 18.8473C19.1051 18.5894 19.25 18.2397 19.25 17.875V9.93008C19.25 9.73978 19.2106 9.55155 19.1341 9.37729C19.0576 9.20303 18.9458 9.04655 18.8057 8.91774ZM17.875 17.875H4.125V9.93008L4.13445 9.92149L11 3.4375L17.8664 9.91977L17.8759 9.92836L17.875 17.875Z",
    fill: "#2357A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.9375C11.3797 8.9375 11.6875 9.2453 11.6875 9.625V11.6875L13.75 11.6875C14.1297 11.6875 14.4375 11.9953 14.4375 12.375C14.4375 12.7547 14.1297 13.0625 13.75 13.0625L11.6875 13.0625V15.125C11.6875 15.5047 11.3797 15.8125 11 15.8125C10.6203 15.8125 10.3125 15.5047 10.3125 15.125V13.0625H8.25C7.8703 13.0625 7.5625 12.7547 7.5625 12.375C7.5625 11.9953 7.8703 11.6875 8.25 11.6875H10.3125V9.625C10.3125 9.2453 10.6203 8.9375 11 8.9375Z",
    fill: "#2357A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoActive);
export default __webpack_public_path__ + "static/media/nav-logo-active.e41a9af948796cf0cca7978a64547ad2.svg";
export { ForwardRef as ReactComponent };